const STORAGE_OBJECT_PATH = "/storage/v1/object/public/";

export function optimizedImageUrl(src: string, width: number, quality = 76, resize: "contain" | "cover" = "contain") {
  if (!src.includes(STORAGE_OBJECT_PATH)) return src;

  const url = new URL(src);
  url.pathname = url.pathname.replace(STORAGE_OBJECT_PATH, "/storage/v1/render/image/public/");
  url.searchParams.set("width", String(width));
  url.searchParams.set("quality", String(quality));
  url.searchParams.set("resize", resize);
  return url.toString();
}